import { isWindowDefined } from "@huub-web/utils";

/**
 * Request animation frame after skipping specified number of frames.
 * @param callback - Function to execute after specified frames
 * @param frames - Number of frames to skip before executing callback (default: 1)
 * @returns Request animation frame ID or null if in SSR environment
 */
export const nextFrame = (callback: () => void, frames = 1): number | null => {
  if (!isWindowDefined()) {
    // Fallback for server-side rendering
    setTimeout(callback, 0);
    return null;
  }

  let frameCount = 0;

  const scheduleFrame = (): number | null => {
    if (!isWindowDefined()) {
      setTimeout(callback, 0);
      return null;
    }

    return window.requestAnimationFrame(() => {
      if (!isWindowDefined()) {
        setTimeout(callback, 0);
        return null;
      }
      if (frameCount < frames) {
        frameCount++;
        scheduleFrame();
      } else {
        callback();
      }
    });
  };

  return scheduleFrame();
};
